//#region src/util/flags.ts
const pwaFlags = ["addToHome", "addToContacts"];
const getFlagName = (pwaId, flag) => {
	switch (flag) {
		case "addToContacts": return `${pwaId}:hide-add-contact`;
		case "addToHome": return `${pwaId}:hide-quick-access`;
		default: return "";
	}
};

//#endregion
export { getFlagName, pwaFlags };